import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'sankyo_lang';

function getInitialLanguage() {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === 'ja' ? 'ja' : 'en';
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  const setLanguage = useCallback((lang) => {
    const next = lang === 'ja' ? 'ja' : 'en';
    localStorage.setItem(STORAGE_KEY, next);
    setLanguageState(next);
  }, []);

  const toggleLanguage = useCallback(() => {
    setLanguage(language === 'ja' ? 'en' : 'ja');
  }, [language, setLanguage]);

  // Dot-path lookup (e.g. "common.contactUs") with an English fallback so a
  // missing Japanese string never renders blank.
  const t = useCallback((path) => {
    const lookup = (dict) => path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), dict);
    return lookup(translations[language]) ?? lookup(translations.en) ?? path;
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage, toggleLanguage, t }), [language, setLanguage, toggleLanguage, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
